<template>
    <el-tab-pane
        class="redesign-element-tab-pane"
        v-bind="attrs"
        v-on="listeners"
    >
        <!-- Custom label -->
        <template
            v-if="$slots.label"
            #label
        >
            <slot name="label" />
        </template>

        <!-- Default content -->
        <slot />
    </el-tab-pane>
</template>

<script setup lang="ts">
import { TabPane as ElTabPane } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const attrs = useAttrs()
const listeners = useListeners()
</script>

<style lang="scss">
.el-tab-pane.redesign-element-tab-pane {
  @apply p-0;
}
</style>
